<template>
  <v-data-table
    :headers="headersSolucoes"
    :items="solutions"
    item-key="solucao.municipioSolucaoId"
    class="elevation-1 evidenciar"
    loading-text="Obtendo informações ..."
    show-expand
    single-expand
    hide-default-footer
    disable-pagination
    @item-expanded="getTasks"
    :loading="loading"
  >
    <template v-slot:item.andamento="{ item }">
      {{ item.tarefasConcluidas }} / {{ item.totalTarefas }}
    </template>

    <template v-slot:item.percental="{ item }">
      {{ item.percentual }} %
    </template>
    <template v-slot:expanded-item="{ item }">
      <td colspan="4" class="td-without-padding">
        <app-tasks-table
          :tasks="tarefas"
          :loading="loadingTasks"
        ></app-tasks-table>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import AppTasksTable from './TasksTable'
import { administrativeDashboardAPI } from '@/modules/administrative-dashboard'

export default {
  components: {
    AppTasksTable
  },
  props: {
    solutions: { type: Array, required: true },
    loading: { type: Boolean, required: false, default: true }
  },
  data () {
    return {
      headersSolucoes: [
        { text: 'Nome da Solução', value: 'solucao.nome' },
        { text: 'Andamento', value: 'andamento' },
        { text: 'Percentual', value: 'percentual' }
      ],
      tarefas: [],
      loadingTasks: true
    }
  },
  methods: {
    getTasks (item) {
      this.loadingTasks = true
      this.tarefas = []
      administrativeDashboardAPI.getDashboardTarefas(item.item.solucao.municipioSolucaoId)
        .then(resp => {
          this.tarefas = resp.data
          this.loadingTasks = false
        })
        .catch(resp => {
          this.$notification.error('Erro ao buscar soluções')
          this.loadingTasks = false
        })
    }
  }
}
</script>

<style lang="scss">@import './style.scss';</style>
